<script setup lang="ts">
import { useNotificationInjection } from '@/composables/useNotification';
import Notification from '@/components/Notification.vue';

const { notification, clear } = useNotificationInjection();
</script>

<template>
  <div class="notification-container">
    <Transition name="fade">
      <Notification
        v-if="notification"
        :message="notification.message"
        :message-type="notification.type"
        :details="notification.details"
        @closed="clear"
      />
    </Transition>
  </div>
</template>

<style scoped>
.notification-container {
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;
  left: 0;
  pointer-events: none; /* Allow clicks to pass through the container */
}

.notification-container > * {
  pointer-events: auto; /* Re-enable pointer events for the notification itself */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style>